export function getRoomKey(room: { id?: string; name?: string | null }, index: number) {
  return room.id || `${room.name || 'room'}-${index}`;
}
